"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyRange = void 0;
function applyRange(factory, start, count) {
    if (count < 0) {
        throw new Error('Count must be greater than or equal to 0');
    }
    if (start + count >= Number.MAX_SAFE_INTEGER) {
        throw new Error('start + count must be less than Number.MAX_SAFE_INTEGER');
    }
    function* generator() {
        for (let i = start; i < start + count; i++) {
            yield i;
        }
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyRange = applyRange;
//# sourceMappingURL=applyRange.js.map